import { spinGame } from "./wheel-game.js";
import { spinMachine } from "./slot-machine.js";
import { loader } from "./utils/loader.js";
import { toggleMusic } from "./utils/btn-musicToggle.js";
import {
  playBackgroundMusic,
  playSlotSpinSound,
  threeSpinSound,
  winSpinSound,
  finalSound,
} from "./utils/sound.js";

window.playBackgroundMusic = playBackgroundMusic;
window.playSlotSpinSound = playSlotSpinSound;
window.threeSpinSound = threeSpinSound;
window.winSpinSound = winSpinSound;
window.finalSound = finalSound;

document.addEventListener("DOMContentLoaded", () => {
  const spinButton = document.querySelector(".button-spin");
  const toggleMusicBtn = document.querySelector(".musicToggle");

  if (!spinButton || !toggleMusicBtn) return;

  loader();

  spinButton.addEventListener("click", () => {
    const currentDataSpin = spinButton.dataset.spin;
    currentDataSpin === "wheels" ? spinGame() : spinMachine();
  });

  toggleMusicBtn.addEventListener("click", () => {
    toggleMusic();
  });
});
